import fetch from '~/util/fetch';

declare var API_URL: string;

const fetchPitchingRecords = async (leagueSlug, boxScoreId) => {
  try {
    const response = await fetch(
      `${API_URL}/${leagueSlug}/box_scores/${boxScoreId}/pitching_records`
    );
    const json = await response.json();
    return json || [];
  } catch (e) {
    return [];
  }
};

const fetchPlayerRecords = async (leagueSlug, boxScoreId) => {
  try {
    const response = await fetch(
      `${API_URL}/${leagueSlug}/box_scores/${boxScoreId}/player_records`
    );

    const json = await response.json();
    return json || [];
  } catch (e) {
    return [];
  }
};

const fetchGoalieRecords = async (leagueSlug, boxScoreId) => {
  try {
    const response = await fetch(
      `${API_URL}/${leagueSlug}/box_scores/${boxScoreId}/goalie_records`
    );
    const json = await response.json();
    return json || [];
  } catch (e) {
    return [];
  }
};

export default async (league, boxScoreId) => {
  const leagueSlug = league.slug;

  if (league.sport_name === 'soccer') {
    const [playerRecords, goalieRecords] = await Promise.all([
      fetchPlayerRecords(leagueSlug, boxScoreId),
      fetchGoalieRecords(leagueSlug, boxScoreId),
    ]);

    const defenderRecords = playerRecords.filter(player => player.position === 'Defender');
    const midfielderRecords = playerRecords.filter(player => player.position === 'Midfielder');
    const forwardRecords = playerRecords.filter(player => player.position === 'Forward');
    const substituteRecords = playerRecords.filter(player => player.starter === false);

    return [
      {
        type: 'Goalkeeper',
        stats: goalieRecords,
      },
      { type: 'Defender', stats: defenderRecords },
      { type: 'Midfielder', stats: midfielderRecords },
      { type: 'Forward', stats: forwardRecords },
      { type: 'Substitute', stats: substituteRecords },
    ];
  }
  switch (leagueSlug) {
    case 'nhl': {
      const [playerRecords, goalieRecords] = await Promise.all([
        fetchPlayerRecords(leagueSlug, boxScoreId),
        fetchGoalieRecords(leagueSlug, boxScoreId),
      ]);

      return [{ type: 'goalies', stats: goalieRecords }, { type: 'skaters', stats: playerRecords }];
    }
    case 'mlb': {
      const [playerRecords, pitchingRecords] = await Promise.all([
        fetchPlayerRecords(leagueSlug, boxScoreId),
        fetchPitchingRecords(leagueSlug, boxScoreId),
      ]);
      return [
        { type: 'batting', stats: playerRecords },
        { type: 'pitching', stats: pitchingRecords },
      ];
    }
    case 'wcbk':
    case 'ncaab':
    case 'wnba':
    case 'nba': {
      const playerRecords = await fetchPlayerRecords(leagueSlug, boxScoreId);
      return [{ type: 'roster', stats: playerRecords }];
    }
    case 'ncaaf': {
      const playerRecords = await fetchPlayerRecords(leagueSlug, boxScoreId);

      const passingRecords = playerRecords.filter(record =>
        record.position_types.includes('passing')
      );
      const rushingRecords = playerRecords.filter(record =>
        record.position_types.includes('rushing')
      );
      const receivingRecords = playerRecords.filter(record =>
        record.position_types.includes('receiving')
      );
      const kickingRecords = playerRecords.filter(record =>
        record.position_types.includes('kicking')
      );
      const kickReturningRecords = playerRecords.filter(record =>
        record.position_types.includes('kick_returning')
      );
      const puntingRecords = playerRecords.filter(record =>
        record.position_types.includes('punting')
      );
      const puntReturningRecords = playerRecords.filter(record =>
        record.position_types.includes('punt_returning')
      );
      const defendingRecords = playerRecords.filter(record =>
        record.position_types.includes('defending')
      );

      return [
        { type: 'passing', stats: passingRecords },
        { type: 'rushing', stats: rushingRecords },
        { type: 'receiving', stats: receivingRecords },
        { type: 'kicking', stats: kickingRecords },
        { type: 'kick_returning', stats: kickReturningRecords },
        { type: 'punting', stats: puntingRecords },
        { type: 'punt_returning', stats: puntReturningRecords },
        { type: 'defending', stats: defendingRecords },
      ];
    }
    case 'cfl':
    case 'nfl': {
      const playerRecords = await fetchPlayerRecords(leagueSlug, boxScoreId);
      const passingRecords = playerRecords.filter(record =>
        record.position_types.includes('passing')
      );
      const rushingRecords = playerRecords.filter(record =>
        record.position_types.includes('rushing')
      );
      const receivingRecords = playerRecords.filter(record =>
        record.position_types.includes('receiving')
      );
      const kickingRecords = playerRecords.filter(record =>
        record.position_types.includes('kicking')
      );
      const kickReturningRecords = playerRecords.filter(record =>
        record.position_types.includes('kick_returning')
      );
      const puntingRecords = playerRecords.filter(record =>
        record.position_types.includes('punting')
      );
      const puntReturningRecords = playerRecords.filter(record =>
        record.position_types.includes('punt_returning')
      );
      const defendingRecords = playerRecords.filter(record =>
        record.position_types.includes('defending')
      );

      return [
        { type: 'passing', stats: passingRecords },
        { type: 'rushing', stats: rushingRecords },
        { type: 'receiving', stats: receivingRecords },
        { type: 'kicking', stats: kickingRecords },
        { type: 'kick_returning', stats: kickReturningRecords },
        { type: 'punting', stats: puntingRecords },
        { type: 'punt_returning', stats: puntReturningRecords },
        { type: 'defending', stats: defendingRecords },
      ];
    }
    default:
      return null;
  }
};
